import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ModalHeader from '../common/modal/header';
import DotLoader from '@/common/dot-loader';

const ProfileDeletionModal = ({ closeModal, headoffice, onSuccess }) => {
    const [t] = useTranslation('common');
    const [status, setStatus] = useState('pending'); // "pending" | "loading" | "failed" | "success"

    const onClick = () => {
        setStatus('loading');
        Mobi2Go.Customer.requestProfileDeletion()
            .then(res => {
                setStatus('success');
                onSuccess();
            })
            .catch(err => {
                if (
                    err &&
                    err.responseJSON &&
                    err.responseJSON.error ===
                        'Profile deletion failed, but an email has been sent to support'
                ) {
                    setStatus('email-sent');
                } else {
                    setStatus('failed');
                }
            });
    };

    const RenderOkButton = () => (
        <button className="m2g-button" onClick={closeModal}>
            {t('ok')}
        </button>
    );

    let titleKey, bodyKey, footerComponent;

    switch (status) {
        case 'success':
            titleKey =
                'customer.profile-deletion:profile_deletion_confirmed_title';
            bodyKey = 'customer.profile-deletion:profile_deletion_confirmed';
            footerComponent = <RenderOkButton />;
            break;
        case 'failed':
            titleKey = 'customer.profile-deletion:deletion_failed_title';
            bodyKey = 'customer.profile-deletion:deletion_failed';
            footerComponent = <RenderOkButton />;
            break;
        case 'email-sent':
            titleKey = 'customer.profile-deletion:email_sent_title';
            bodyKey =
                'customer.profile-deletion:profile_deletion_failed_email_sent';
            footerComponent = <RenderOkButton />;
            break;
        default:
            titleKey = 'customer.profile-deletion:mobile_page_title';
            bodyKey = 'customer.profile-deletion:profile_deletion_question';
            footerComponent = (
                <>
                    <button
                        disabled={status === 'loading'}
                        className="m2g-button m2g-button--primary"
                        onClick={onClick}
                    >
                        {status === 'loading' ? (
                            <DotLoader dotCharacter="•" />
                        ) : (
                            t('yes')
                        )}
                    </button>
                    <button
                        disabled={status === 'loading'}
                        className="m2g-button m2g-button--secondary"
                        onClick={closeModal}
                    >
                        {t('no')}
                    </button>
                </>
            );
            break;
    }

    return (
        <div className="m2g-profile-deletion">
            <ModalHeader
                headerText={t(titleKey)}
                onClose={closeModal}
                hideCloseButton={status === 'success'}
            />
            <div className="m2g-modal-body m2g-text--center">
                {t(bodyKey, {
                    headoffice: headoffice?.display_name,
                })}
            </div>
            <div className="m2g-modal-footer">
                <div className="m2g-modal-footer-right">{footerComponent}</div>
            </div>
        </div>
    );
};

export default ProfileDeletionModal;
